module.exports = __webpack_public_path__ + "static/media/s8.21ca1ff2.ogg";